import axios from 'axios';
import { $addClass, $closest, $data, $find, $qs, $qsa, $setAttr, $setHTML, $setOuterHTML } from 'fxdom/es';
import { chunk, each, find, go, mapC } from 'fxjs/es';
import { UtilF } from '../../../Util/F/Function/module/UtilF.js';
import { UtilObjS } from '../../../Util/Object/S/Function/module/UtilObjS.js';
import { makeApiUrl } from '../../../Util/S/Function/util.js';
import { NessLabsTmplS } from '../../S/Tmpl/module/NessLabsTmplS.js';
import { CharacterValidator } from './events.js';
import { NessLabsF } from './module/NessLabsF.js';
import { autoUpdateSaleInfo, setMakerImageInCharacter } from './product.js';
import { NessUtilF } from '../../../Ness/Util/F/Function/module/NessUtilF.js';
import { CharacterValidatorS } from '../../S/Function/character.js';

const CONCURRENCY = NessUtilF.isMobile() ? 2 : 4;

function labsHomeProductImageLoads() {
  return loadProductListImages(CONCURRENCY);
}

export const startNessLabs = async (ness_labs_container_el) => {
  const { characters, stop_load } = box();
  if (characters.length && !stop_load) {
    UtilF.measureExecutionTime(labsHomeProductImageLoads).then();
  }
  go(ness_labs_container_el, NessLabsF.events, NessLabsF.paginationEvent(refreshProductList));

  const current_character = CharacterValidatorS.findSelectedCharacter(characters);
  CharacterValidator.handleCollaboError(current_character, true) ||
    CharacterValidator.handleOldCharacterError(current_character, true);

  autoUpdateSaleInfo();
};

export const refreshProductList = async (pagination_state = NessLabsF.getPaginationState()) => {
  try {
    $.don_loader_start();
    const search_params = new URLSearchParams(window.location.search);
    const cate_list_id = search_params.get('cate_list_id');

    const {
      data: { products },
    } = await axios.get(makeApiUrl(`/:lang/@api/ness/labs_product_list`, { lang: T.lang }), {
      params: {
        offset: pagination_state.offset,
        limit: pagination_state.limit,
        cate_list_id,
      },
    });

    go(
      $qs('.labs__content-container'),
      $setOuterHTML(
        NessLabsTmplS.labsContentContainer({
          products,
          ...pagination_state,
        }),
      ),
    );
    UtilF.measureExecutionTime(labsHomeProductImageLoads).then();
  } catch (e) {
  } finally {
    $.don_loader_end();
  }
};

class ProductThumbnails {
  static #instance;

  constructor() {
    const cache_product_thumbnails = window.localStorage.getItem('cache_product_thumbnails');
    this.repository = cache_product_thumbnails ? JSON.parse(cache_product_thumbnails) : {};
    ProductThumbnails.#instance = this;
  }

  static getInstance() {
    if (!ProductThumbnails.#instance) {
      new ProductThumbnails();
    }
    return ProductThumbnails.#instance;
  }

  get(distinct_hash) {
    return this.repository[distinct_hash];
  }

  set(distinct_hash, url) {
    this.repository[distinct_hash] = url;
    window.localStorage.setItem('cache_product_thumbnails', JSON.stringify(this.repository));
  }
}

const loadProductListImages = async (concurrency) => {
  const condition = getCurrentCondition();
  const { character } = condition;

  if (!character) return;
  if (CharacterValidatorS.isInvalidCharacter(character)) return;
  if (!(await setMakerImageInCharacter(character))) return;

  await go(
    $qsa('.maple-labs-product-list-item:not(.already_composite)'),
    chunk(concurrency),
    each(
      mapC(async (item_el) => {
        if (!verifyCondition(condition, getCurrentCondition()) || box().stop_load) return;

        const product = UtilObjS.deepClone($data(item_el));
        const thumb = go(
          product.thumbnails.value,
          find((thumb) => {
            return thumb.is_thumb;
          }),
        );
        const maker_type = product._.base_product.maker_type;
        const thumbnails = await NessLabsF.getCachedThumbnails({
          thumbnails: [thumb],
          product,
          character,
          size_px: 600,
          maker_type,
        });
        if (thumbnails) {
          thumb.url = thumbnails[0].url;
          thumb.is_not_yet = false;
        } else {
          if (
            !(await NessLabsF.setProductFace({
              product,
              maker_type,
              character,
              selected_option_group: product._.selected_option_group,
              original_product_faces2: product.product_faces2,
              is_thumb: true,
            }))
          )
            return;

          if (
            !(await NessLabsF.setCompositeThumbnail({
              thumb,
              product,
              thumbnail_size: 600,
              maker_type,
              character,
              composite_template_id: thumb.composite_template_id,
            }))
          )
            return;
        }

        if (item_el.parentNode && !box().stop_load)
          go(item_el, $setOuterHTML(NessLabsTmplS.makeProductItem(product)));
      }),
    ),
  );
};

export const resetProductList = () => {
  go(
    $qsa('.maple-labs-product-list-item'),
    each((itemEl) => {
      go(itemEl, $find('.maple-labs-product-list-item__body'), $addClass('is_not_yet'));
      go(
        itemEl,
        $find('.maple-labs-product-list-item__button'),
        $setHTML('Rendering...'),
        $setAttr({ disabled: true }),
      );
    }),
  );
};

export const getCharacterSettingData = (el = $qs('.labs__main-container__content')) => {
  const container = go(el, $find('.labs__main-container__img-container > canvas '));
  if (!container) return;
  return $data(container);
};

const getCurrentCondition = () => ({
  character: getCharacterSettingData(),
  currentPage: NessLabsF.getCurrentPage(),
});

const verifyCondition = (initial, current) => {
  return (
    CharacterValidatorS.compareCharacter(initial.character, current.character) &&
    initial.currentPage === current.currentPage
  );
};

export const handleProductFiltering = (element) => {
  if (!element) return;

  const cate_list_el = go(
    element,
    $closest('.ness-plus-product-list'),
    $find(`.labs__category__item.category.selected`),
  );

  const search_params = new URLSearchParams(window.location.search);
  search_params.set('cate_list_id', cate_list_el?.dataset.id);
  if (search_params.has('page')) {
    search_params.delete('page');
  }
  return (window.location.href = `${window.location.pathname}?${search_params.toString()}`);
};
